import {
    GET_LEADS_REQUEST,
    GET_LEADS_SUCCESS,
    GET_LEADS_FAILURE,
} from './actions';

const initialState = {
    leads: [],
    loading: false,
    error: null,
};

const leadsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LEADS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_LEADS_SUCCESS:
            return {
                ...state,
                leads: action.payload,
                loading: false,
                error: null,
            };
        case GET_LEADS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default leadsReducer;